(function(){
  var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ATTR_TARGET = '#app-embed[data-form-root="true"]';
  var ATTR_NAME = 'data-current-step';
  var ATTR_SUCCESS_VALUE = 'success';
  var BANNER_SELECTOR = '[data-testid="banner-success"]';

  function showCTA(nativeNode){
    var cta = document.querySelector('[data-ws-cta-on-success]');
    if (!cta) return;
    
    cta.hidden = false;
    cta.style.removeProperty('display');
    cta.classList.add('ws-cta-visible'); 
    
    var formBlockParent = document.querySelector('#shopify-block-AZjJWU0owNTBkN2xFd__forms_inline_hFBwLH');
    
    if (formBlockParent) {
        formBlockParent.style.setProperty('display', 'none', 'important'); 
    }
    
    if (nativeNode) {
        nativeNode.style.display = 'none';
        nativeNode.style.setProperty('display', 'none', 'important');
    }
  }

  function queryDeepAll(sel, root){
    var out = [];
    function walk(r){
      try{ r.querySelectorAll && r.querySelectorAll(sel).forEach(function(n){ out.push(n); }); }catch(e){}
      if (!r.childNodes) return;
      r.childNodes.forEach(function(node){
        if (node.nodeType === 1){
          if (node.shadowRoot) walk(node.shadowRoot);
          walk(node);
        }
      });
    }
    walk(root || document);
    return out;
  }

  function isVisible(el){
    if (!el) return false;
    var rects = el.getClientRects && el.getClientRects();
    return (el.offsetParent !== null) || (rects && rects.length > 0);
  }

  function checkSuccess(){
    var root = document.querySelector(ATTR_TARGET);
    
    if (root && root.getAttribute(ATTR_NAME) === ATTR_SUCCESS_VALUE){
      var banner = document.querySelector(BANNER_SELECTOR) || root;
      showCTA(banner);
      return true;
    }
    
    var banners = queryDeepAll(BANNER_SELECTOR, document);
    var visible = banners.find(isVisible);
    if (visible){
      showCTA(visible);
      return true;
    }
    return false;
  }

  var moRoot = null;
  var moDoc = null;
  var poll = null;
  var mainRoot = document.querySelector(ATTR_TARGET) || document.body;

  function disconnectAll(){
    if (moRoot) moRoot.disconnect();
    if (moDoc) moDoc.disconnect();
    if (poll) clearInterval(poll);
    moRoot = moDoc = poll = null;
  }

  function hookRootObserver(root){
    if (moRoot) moRoot.disconnect();
    moRoot = new MutationObserver(function(){
      if (checkSuccess()){ disconnectAll(); }
    });
    moRoot.observe(root, { attributes: true, attributeFilter: [ATTR_NAME] });
  }

  function startPoll(){
    if (poll) clearInterval(poll);
    var tries = 0;
    poll = setInterval(function(){
      tries++;
      if (checkSuccess() || tries > 48) { 
        clearInterval(poll);
        poll = null;
      }
    }, 250);
  }

  function setupObservers(){
    if (checkSuccess()) return;

    if (!moDoc){
      moDoc = new MutationObserver(function(){
        var root = document.querySelector(ATTR_TARGET);
        if (root) {
          moDoc.disconnect();
          hookRootObserver(root);
          if (!poll) startPoll(); 
        }
        if (checkSuccess()) disconnectAll();
      });
      moDoc.observe(document.body, { childList: true, subtree: true });
    }
    
    var root = document.querySelector(ATTR_TARGET);
    if (root) hookRootObserver(root);
    
    startPoll();
  }

  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){ 
          setupObservers(); 
        } else { 
          disconnectAll(); 
        }
      });
    }, {root:null, threshold:0});

    io.observe(mainRoot);

  } else {
    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', setupObservers, {once:true, passive:true});
    } else {
      setupObservers();
    }
  }

  document.querySelectorAll('.ws-benefits-track').forEach(function(track){
    if (track.dataset.wsInit === '1') return;
    track.dataset.wsInit = '1';
    if (prefersReduce) return;

    var state = { x:0, last:0, raf:0, playing:false, half:0, origCount:0 };
    var speed = parseFloat(track.dataset.speed || '40');
    var wrap = track.closest('.ws-track-outer');

    function cloneOnce(){
      if (state.origCount) return;
      var kids = Array.prototype.slice.call(track.children);
      state.origCount = kids.length;
      for (var i=0;i<state.origCount;i++) track.appendChild(kids[i].cloneNode(true));
    }

    function measure(){
      if (!state.origCount) cloneOnce();
      var gap = parseFloat(getComputedStyle(track).gap || 0);
      var sum = 0;
      for (var i=0;i<state.origCount;i++){
        var el = track.children[i];
        sum += (el.offsetWidth || el.getBoundingClientRect().width || 0) + gap;
      }
      state.half = sum;
    }

    function loop(ts){
      if (!state.playing) return;
      if (!state.last) state.last = ts;
      var dt = (ts - state.last) / 1000;
      state.last = ts;
      state.x -= speed * dt;
      var w = state.half;
      if (w > 0 && state.x <= -w) state.x += w;
      track.style.transform = 'translate3d(' + state.x + 'px,0,0)';
      state.raf = requestAnimationFrame(loop);
    }

    function play(){
      if (state.playing) return;
      state.playing = true;
      state.last = 0;
      state.raf = requestAnimationFrame(loop);
    }

    function pause(){
      state.playing = false;
      if (state.raf){ cancelAnimationFrame(state.raf); state.raf = 0; }
    }

    function onEnter(){ pause(); }
    function onLeave(){ if (!prefersReduce) play(); }

    var ro = window.ResizeObserver ? new ResizeObserver(function(){ measure(); }) : null;
    if (ro) ro.observe(track);

    var io = window.IntersectionObserver ? new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){ measure(); play(); } else { pause(); }
      });
    }, {root:null, threshold:0}) : null;

    measure();
    if (io){ io.observe(track); } else { play(); }

    if (wrap){
      wrap.addEventListener('mouseenter', onEnter, {passive:true});
      wrap.addEventListener('mouseleave', onLeave, {passive:true});
    }

    document.addEventListener('visibilitychange', function(){
      if (document.hidden) pause(); else if (!prefersReduce) play();
    }, {passive:true});
  });

  document.querySelectorAll('.ws-steps').forEach(function(root){
    if (root.dataset.wsInit === '1') return;
    var tabs    = root.querySelectorAll('[data-step-tab]');
    var panels = root.querySelectorAll('[data-step-panel]');
    if (!tabs.length || !panels.length) return;
    root.dataset.wsInit = '1';

    var auto    = (root.dataset.auto || 'true') === 'true';
    var interval = parseInt(root.dataset.interval || '10000', 10);
    var idx = 0, timer;
    var container = root.querySelector('.ws-panels');

    panels.forEach(function(p){
      p.hidden = false; p.classList.remove('is-active'); p.style.display = 'none'; p.style.opacity = 0;
    });

    function calcMax(){
      if (!container) return;
      var maxH = 0;
      for (var i=0;i<panels.length;i++){
        var p = panels[i];
        var prev = p.style.display;
        p.style.display = 'block';
        var h = p.scrollHeight;
        if (h > maxH) maxH = h;
        p.style.display = prev;
      }
      container.style.height = maxH + 'px';
    }

    function show(i){
      idx = (i + tabs.length) % tabs.length;
      for (var t=0;t<tabs.length;t++) tabs[t].classList.toggle('is-active', t===idx);
      for (var k=0;k<panels.length;k++){
        var p = panels[k];
        if (k === idx){
          p.style.display = 'block';
          requestAnimationFrame(function(){ panels[idx] && panels[idx].classList.add('is-active'); });
        } else {
          p.classList.remove('is-active');
          (function(pp){ setTimeout(function(){ if (!pp.classList.contains('is-active')) pp.style.display = 'none'; }, 350); })(p);
        }
      }
    }

    function restart(){
      if (timer) clearInterval(timer);
      if (auto && !prefersReduce) timer = setInterval(function(){ show(idx+1); }, interval);
    }

    calcMax();
    if (window.ResizeObserver){
      var ro = new ResizeObserver(function(){ calcMax(); });
      ro.observe(root);
    } else {
      var resizeTO;
      window.addEventListener('resize', function(){
        clearTimeout(resizeTO);
        resizeTO = setTimeout(calcMax, 150);
      }, {passive:true});
    }

    for (var i=0;i<tabs.length;i++){
      (function(ii){
        tabs[ii].addEventListener('click', function(){ show(ii); restart(); }, {passive:true});
      })(i);
    }
    root.addEventListener('mouseenter', function(){ if (timer) clearInterval(timer); }, {passive:true});
    root.addEventListener('mouseleave', function(){ restart(); }, {passive:true});

    show(0); restart();
  });
})();